// import { useFetchStaffsAllDataForWarehouseMerchant } from "../../../apis/staffApis";
// import SelectInput from "../../../components/Select";

// type Props = {
//   register: any;
//   errors: any;
//   clearErrors?: any;
//   setValue?: (name: string, value: any) => void;
//   getIds?: any;
//   watch?: any;
//   control?: any;
//   driverData?: any;
//   setSelectedDocument?: any;
//   pickup?: any;
// };

// const AssignReceiverModal = ({
//   register,
//   errors,
//   clearErrors,
//   setValue,
//   watch,
//   pickup
// }: Props) => {
//   const { data: staffData } = useFetchStaffsAllDataForWarehouseMerchant(pickup?.clientId);

//   return (
//     <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//       <div className="md:w-[550px] sm:w-[450px]  min-h-[350px] overflow-y-auto space-y-4">
//         <SelectInput
//           className="col-span-3"
//           name="staffId"
//           label="Select Staff"
//           placeholder=""
//           selectOptions={
//             Array.isArray(staffData) && staffData?.map((supervisor: any) => ({
//               id: supervisor.id,
//               value: supervisor.id,
//               text: supervisor.name,
//             })) || []
//           }
//           clearErrors={clearErrors}
//           register={register}
//           validation={{ required: "Supervisor is required" }}
//           error={errors.staffId}
//           disabled={!staffData || staffData.length === 0}
//           value={watch("staffId")}
//           setValue={(val: string) => {
//             // only update react-hook-form state
//             setValue?.("staffId", val);
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default AssignReceiverModal;

import { IconUser } from "@tabler/icons-react";
import { useFetchStaffsAllDataForWarehouseMerchant } from "../../../apis/staffApis";
import { useOutletAssignedStaffs } from "../../../apis/staffApis"; // ✅ import new hook
import SelectInput from "../../../components/Select";

type Props = {
  register: any;
  errors: any;
  clearErrors?: any;
  setValue?: (name: string, value: any) => void;
  getIds?: any;
  watch?: any;
  control?: any;
  driverData?: any;
  setSelectedDocument?: any;
  pickup?: any;
};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const AssignReceiverModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  watch,
  pickup,
}: Props) => {
  const manifestType = pickup?.manifestType;

  const { data: merchantStaffs } = useFetchStaffsAllDataForWarehouseMerchant(
    manifestType !== "OUTLET" ? pickup?.clientId : undefined,
  );

  const { data: outletStaffs } = useOutletAssignedStaffs(
    manifestType === "OUTLET" ? pickup?.warehouseId : undefined,
  );

  const staffData =
    manifestType === "OUTLET" ? (outletStaffs ?? []) : (merchantStaffs ?? []);

  return (
    <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3 shadow-sm hover:shadow-md">
      <SectionHeader icon={IconUser} title="Assign Receiver" />
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

      <SelectInput
        className="flex items-center gap-2"
        labelClass="w-full"
        name="staffId"
        label="Select Staff"
        placeholder=""
        selectOptions={
          (Array.isArray(staffData) &&
            staffData?.map((supervisor: any) => ({
              id: supervisor.id,
              value: supervisor.id,
              text: supervisor.name,
            }))) ||
          []
        }
        clearErrors={clearErrors}
        register={register}
        validation={{ required: "Supervisor is required" }}
        error={errors.staffId}
        disabled={!staffData || staffData.length === 0}
        value={watch("staffId")}
        setValue={(val: string) => {
          setValue?.("staffId", val);
        }}
      />
    </div>
  );
};

export default AssignReceiverModal;
